// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListA_TheComp__yqXs0"};